import Sparkline from './Sparkline';

function formatValue(value) {
  const numericValue = Number(value);
  return Number.isFinite(numericValue) ? numericValue.toLocaleString() : '0';
}

const borderColor = { up: 'border-l-green-500', down: 'border-l-red-500', neutral: 'border-l-gray-300' };
const textColor = { up: 'text-green-600', down: 'text-red-600', neutral: 'text-gray-500' };
const sparkColor = { up: 'text-green-500', down: 'text-red-500', neutral: 'text-storm-blue' };
const arrow = { up: '\u25B2', down: '\u25BC', neutral: '' };

function getTrend(delta) {
  return delta > 0 ? 'up' : delta < 0 ? 'down' : 'neutral';
}

export default function TodaySnapshotCard({ card }) {
  const hasAvg = card.avgDelta !== undefined && card.avgDelta !== null;
  const trend = hasAvg ? getTrend(card.avgDelta) : getTrend(card.delta);

  return (
    <div className={`min-w-0 rounded-lg border border-gray-200 border-l-[3px] ${borderColor[trend]} bg-white px-3 py-3 shadow-sm`}>
      <div className="truncate text-[11px] font-semibold uppercase tracking-wide text-gray-500">
        {card.label}
      </div>
      <div className="mt-1 text-2xl font-semibold tabular-nums text-gray-950">
        {formatValue(card.value)}
      </div>
      <Sparkline
        values={card.sparkline || []}
        avg={card.avg7d}
        className={`mt-2 h-8 w-full ${sparkColor[trend]}`}
      />
      {hasAvg ? (
        <>
          <div className={`mt-2 truncate text-xs font-medium ${textColor[trend]}`}>
            {arrow[trend]} {card.avgDeltaLabel}
          </div>
          <div className="truncate text-[11px] text-gray-400">
            {card.deltaLabel}
          </div>
        </>
      ) : (
        <div className={`mt-2 truncate text-xs font-medium ${textColor[trend]}`}>
          {arrow[trend]} {card.deltaLabel}
        </div>
      )}
    </div>
  );
}
